import { WorkOrderDiscountTypeEnum, WorkOrderStatusEnum, WorkOrderTypeEnum } from './../constants/workorder-enum'
import { BomRepairMethodEnum, BomRepairTypeEnum } from '@/constants/bom-enum'
import { _applyType, _orderProcess, _applyStatus, _taskStatus, _repairStatus, _usageMode, _bomCategory, _verifyStatus, _verifyApplyType, _sampleStatus, _bomApplicable, _bomDetailStatus, _sampleProcess, _bomLogicOrderType, _bomLogicProcess, _bomRepairType, _workOrderTypeSet, _workOrderStatusSet, _bomRepairMethod, _orderDiscountType, _userGroup, UserGroupEnum } from './../constants/index'

// Parse the time to string
export const parseTime = (
  time?: object | string | number | null,
  cFormat?: string
): string | null => {
  if (time === undefined || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time as Date
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: { [key: string]: number } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

/**
 * 省略字符串中间值
 * @param str
 * @returns
 */
export const omitString = (str: string) => {
  if (str.length > 10) {
    return str.slice(0, 4) + '...' + str.slice(-4)
  }
  return str
}

/**
 * 隐藏字符串中间值
 * @param str
 * @returns
 */
export const hideString = (str: string) => {
  if (!str) {
    return '-'
  }
  if (str.length > 8) {
    return str.slice(0, 3) + '***' + str.slice(-3)
  }
  return str
}

/**
 * 工单类型过滤
 * @param value
 */
export const workOrderTypeFilter = (value: WorkOrderTypeEnum) => {
  for (const item of _workOrderTypeSet) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 工单状态过滤
 * @param value
 */
export const workOrderStatusFilter = (value: WorkOrderStatusEnum) => {
  for (const item of _workOrderStatusSet) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 维修样本状态过滤
 *
 * @param value
 */
export const sampleStatusFilter = (value: string) => {
  for (const item of _sampleStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 工单流程过滤
 * @param value
 */
export const orderProcessFilter = (value: number) => {
  for (const item of _orderProcess) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 请求单类型过滤
 * @param value
 */
export const applyTypeFilter = (value: number) => {
  for (const item of _applyType) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 请求单类型过滤
 * @param value
 */
export const verifyApplyTypeFilter = (value: number) => {
  for (const item of _applyType) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 请求单状态过滤
 * @param value
 */
export const applyStatusFilter = (value: number) => {
  for (const item of _applyStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 工单任务状态过滤
 * @param value
 */
export const taskStatusFilter = (value: number) => {
  for (const item of _taskStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 维修状态过滤
 * @param value
 */
export const repaireStatusFilter = (value: number) => {
  for (const item of _repairStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 验证状态过滤
 * @param value
 */
export const verifyStatusFilter = (value: number) => {
  for (const item of _verifyStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * BOM类别过滤
 * @param value
 */
export const bomCategoryFilter = (value: number) => {
  for (const item of _bomCategory) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * BOM适配类别
 * @param value
 */
export const bomApplicableFilter = (value: number | string, applicableList: any[]) => {
  if (!applicableList.length) {
    applicableList = _bomApplicable
  }
  if (typeof value === 'string') {
    const arr = value.split(',')
    const result = arr.map((v) => {
      for (const item of applicableList) {
        // eslint-disable-next-line eqeqeq
        if (item.value == parseInt(v)) {
          return item.label
        }
      }
      return '---'
    })
    return result.join()
  } else if (typeof value === 'number') {
    for (const item of applicableList) {
      // eslint-disable-next-line eqeqeq
      if (item.value == value) {
        return item.label
      }
    }
    return '---'
  }
}

/**
 * BOM消费方式过滤
 * @param value
 */
export const usageModeFilter = (value: number) => {
  for (const item of _usageMode) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 物料位置
 * @param value
 */
export const bomDetailFilter = (value: number) => {
  for (const item of _bomDetailStatus) {
    if (item.value === value) {
      return item.label
    }
  }
  return '---'
}

/**
 * BOM消费验证过滤
 * @param value
 */
export const bomValidationFilter = (value: number) => {
  if (value && value === 1) {
    return 'common.yes'
  } else {
    return 'common.no'
  }
}

/**
 * 物料工单逻辑
 * @param value
 */
export const bomLogicOrderFilter = (value: WorkOrderTypeEnum) => {
  for (const item of _bomLogicOrderType) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 物料流程逻辑
 * @param value
 */
export const bomLogicProcessFilter = (value: string) => {
  for (const item of _bomLogicProcess) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 样本流程位置
 * @param value
 */
export const sampleProcessFilter = (value: number) => {
  for (const item of _sampleProcess) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 维修物料类型
 *
 * @param value
 */
export const bomRepairTypeFilter = (value: BomRepairTypeEnum) => {
  for (const item of _bomRepairType) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 维修方法
 *
 * @param value
 */
export const bomRepairMethodFilter = (value: BomRepairMethodEnum) => {
  for (const item of _bomRepairMethod) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 工单折扣类型
 *
 * @param value
 */
export const orderDiscountTypeFilter = (value: WorkOrderDiscountTypeEnum) => {
  for (const item of _orderDiscountType) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return '---'
}

/**
 * 权限组类型
 *
 * @param value
 */
export const userGroupFilter = (value: UserGroupEnum) => {
  for (const item of _userGroup) {
    // eslint-disable-next-line eqeqeq
    if (item.value == value) {
      return item.label
    }
  }
  return ''
}
